import { API_BASE } from "../../config";

// A raw PDF link has no Open Graph tags for WhatsApp's link-preview crawler
// to read, so it fell back to showing the bare domain three times over (see
// server/index.js's GET /share for the actual fix) - wrapping the PDF link
// in that branded landing page is what gives the shared message a real
// title, business logo, and a proper button instead.
export function buildShareLandingUrl(pdfUrl, title, subtitle) {
  const params = new URLSearchParams({ pdfUrl });
  if (title) params.set("title", title);
  if (subtitle) params.set("subtitle", subtitle);
  return `${API_BASE}/share?${params.toString()}`;
}

// No phone number in the wa.me link since a report isn't addressed to one
// customer - WhatsApp opens its own contact picker instead.
export function whatsappShareUrl(pdfUrl, title, subtitle) {
  return `https://wa.me/?text=${encodeURIComponent(buildShareLandingUrl(pdfUrl, title, subtitle))}`;
}

// Regenerates the PDF for the current filters (so what gets shared always
// matches what's on screen, never a stale file from an earlier export) and
// opens WhatsApp on success instead of the usual "open the PDF in a new tab"
// - both would otherwise fire from the same run() call.
export function shareReportViaWhatsapp(reportExport, { label, create, fetch, fileName, pdfUrl, subtitle }) {
  reportExport.run({
    label,
    create,
    fetch,
    fileName,
    onSuccess: () => window.open(whatsappShareUrl(pdfUrl, label, subtitle), "_blank"),
  });
}
